export default __webpack_public_path__ + "static/hero-mockup-light-4bf9c64be27a873a81915f8f72397336.png";